var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105.18627mm",
    height: "102.08012mm",
    viewBox: "0 0 105.18627 102.08012",
    id: "svg1347",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1344"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-44.30998,-137.17437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3206",
    style: {
      color: "#000000",
      fill: "#5daf00",
      fillOpacity: 0.179601,
      strokeWidth: "0.999999px",
      InkscapeStroke: "none"
    },
    d: "m 293.91016,522.55859 c -0.72197,0.2143 -1.44008,0.4388 -2.15625,0.67188 -0.58881,0.36246 -1.17641,0.72681 -1.76368,1.0918 -42.06186,26.14121 -72.03639,53.60617 -91.99414,81.47656 -36.01297,52.21509 -40.05859,114.49715 -12.67773,166.35156 31.15474,52.6686 78.96458,88.84867 131.31641,110.75781 55.64308,21.31332 116.76096,29.66381 170.42187,11.0625 34.38529,-17.0613 68.14467,-33.19941 76.99024,-69.65234 2.38348,-17.64641 1.16178,-31.24232 -12.21485,-41.88867 -3.57241,-2.80279 -7.52908,-4.9398 -11.58398,-6.63477 -3.87209,-1.61854 -7.98914,-2.89725 -12.20313,-3.97461 -17.89514,-4.29306 -35.83112,-6.13978 -52.41601,-10.47265 -8.48429,-2.24421 -16.74178,-5.14471 -24.29883,-9.21485 -7.24161,-3.90021 -13.91678,-8.91293 -19.63086,-15.61914 -5.43481,-6.3784 -10.32328,-14.66273 -13.9336,-25.74805 -6.87923,-31.18639 0,0 -20.49023,-84.11914 C 376.9978,550.74398 357.78787,503.88156 293.91016,522.55859 Z",
    transform: "scale(0.26458333)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundShape);
export default __webpack_public_path__ + "static/media/background-shape.7003da1b0b1c45cfb66776a5a590957b.svg";
export { ForwardRef as ReactComponent };